// Social Media Service Page Content
import { FaInstagram, FaFacebook, FaTiktok, FaChartLine, FaUsers, FaBullhorn, FaCalendarAlt, FaPencilAlt, FaComments, FaFileAlt, FaCamera, FaCheckCircle, FaLightbulb, FaPaperPlane } from 'react-icons/fa';
import { MdSchedule } from 'react-icons/md';

export const socialMediaContent = {
  hero: {
    title: "إدارة احترافية لحساباتك على السوشيال ميديا",
    subtitle: "نُدير حساباتك بمحتوى جذاب ومميز يزيد تفاعل جمهورك ويبني علاقة قوية مع عملائك",
    buttonText: "ابدأ الآن",
    imageUrl: "https://via.placeholder.com/800x500/1A4D5C/2DD4BF?text=Social+Media"
  },

  whyNeed: {
    title: "لماذا السوشيال ميديا مهمة لمشروعك؟",
    subtitle: "وجودك على منصات التواصل الاجتماعي أصبح ضرورة لنجاح أي مشروع",
    reasons: [
      {
        id: 1,
        icon: FaUsers,
        title: "جمهورك موجود هناك",
        description: "أكثر من 25 مليون مستخدم سعودي نشط يومياً"
      },
      {
        id: 2,
        icon: FaComments,
        title: "التواصل المباشر",
        description: "تتواصل مع عملائك وتبني علاقة ثقة"
      },
      {
        id: 3,
        icon: FaBullhorn,
        title: "زيادة الوعي بعلامتك",
        description: "تصل لآلاف العملاء المحتملين"
      },
      {
        id: 4,
        icon: FaChartLine,
        title: "استهداف دقيق",
        description: "تصل للجمهور المناسب في الوقت المناسب"
      }
    ]
  },

  whatWeOffer: {
    title: "ماذا نقدم لك؟",
    features: [
      {
        id: 1,
        icon: FaInstagram,
        title: "إدارة الحسابات",
        description: "إدارة Instagram, Facebook, TikTok, X بشكل احترافي"
      },
      {
        id: 2,
        icon: FaPencilAlt,
        title: "تصميم المنشورات",
        description: "تصاميم جذابة تعكس هوية علامتك"
      },
      {
        id: 3,
        icon: FaFileAlt,
        title: "كتابة المحتوى",
        description: "نصوص إبداعية تجذب الانتباه وتحفز التفاعل"
      },
      {
        id: 4,
        icon: MdSchedule,
        title: "جدولة المنشورات",
        description: "ننشر في الأوقات الأنسب للوصول الأعلى"
      },
      {
        id: 5,
        icon: FaComments,
        title: "إدارة التفاعل",
        description: "نرد على التعليقات والرسائل بسرعة"
      },
      {
        id: 6,
        icon: FaChartLine,
        title: "تحليل الأداء",
        description: "تقارير شهرية توضح النمو والإنجازات"
      },
      {
        id: 7,
        icon: FaLightbulb,
        title: "استراتيجية محتوى",
        description: "خطة شهرية مدروسة لتحقيق أهدافك"
      },
      {
        id: 8,
        icon: FaCamera,
        title: "تصوير ومونتاج",
        description: "نصور ونحرر فيديوهات قصيرة (Reels/TikTok)"
      }
    ]
  },

  portfolio: {
    title: "نماذج من أعمالنا في إدارة السوشيال ميديا",
    subtitle: "محتوى إبداعي وحملات ناجحة أدرناها لعملائنا",
    projects: [
      {
        id: 1,
        title: "حملة إنستغرام - متجر أزياء",
        platform: "Instagram",
        description: "إدارة حساب متجر أزياء نسائية مع محتوى جذاب وتفاعل عالي",
        image: "https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=800&q=80",
        metrics: ["15K متابع", "+400% تفاعل", "25 منشور شهرياً"]
      },
      {
        id: 2,
        title: "حملة فيسبوك - مطعم",
        platform: "Facebook",
        description: "إدارة محتوى مطعم محلي مع تصاميم احترافية وعروض جذابة",
        image: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&q=80",
        metrics: ["8.5K متابع", "+250% طلبات", "رد فوري"]
      },
      {
        id: 3,
        title: "حملة تيك توك - مركز تجميل",
        platform: "TikTok",
        description: "محتوى فيديو قصير جذاب مع ترندات لمركز تجميل وعناية",
        image: "https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?w=800&q=80",
        metrics: ["50K مشاهدة", "12K متابع", "فيديوهات فيرال"]
      },
      {
        id: 4,
        title: "حملة متعددة المنصات - شركة تقنية",
        platform: "Multi-Platform",
        description: "إدارة شاملة لحسابات شركة تقنية على 3 منصات بهوية موحدة",
        image: "https://images.unsplash.com/photo-1557838923-2985c318be48?w=800&q=80",
        metrics: ["3 منصات", "50+ استفسار", "سمعة قوية"]
      },
      {
        id: 5,
        title: "حملة تفاعلية - متجر إلكتروني",
        platform: "Instagram + Facebook",
        description: "حملات تفاعلية ومسابقات زادت الوعي والمبيعات بشكل كبير",
        image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
        metrics: ["مسابقات شهرية", "+180% مبيعات", "تفاعل عالي"]
      },
      {
        id: 6,
        title: "محتوى فيديو - مركز رياضي",
        platform: "Instagram Reels",
        description: "إنتاج محتوى فيديو تحفيزي ومتنوع لمركز رياضي",
        image: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=800&q=80",
        metrics: ["100K مشاهدة", "Reels يومية", "+300 عضو جديد"]
      }
    ]
  },

  packagesSection: {
    title: "باقات مرنة تناسب احتياجاتك",
    subtitle: "اختر الباقة التي تناسب حجم مشروعك وأهدافك"
  },

  packages: [
    {
      id: 'start',
      title: 'باقة الانطلاقة',
      subtitle: 'المشاريع الناشئة والأفراد',
      isFeatured: false,
      features: [
        'إدارة حساب واحد (Instagram أو Facebook)',
        '8 منشورات شهرياً',
        'تصميمات احترافية وجذابة',
        'كتابة محتوى إبداعي',
        'جدولة المنشورات',
        'رد على التعليقات (حتى 50 تعليق)',
        'تقرير بسيط آخر الشهر'
      ],
      whatsappMessage: `مرحباً

أنا مهتم بـــ باقة الانطلاقة لإدارة السوشيال ميديا

تفاصيل الباقة:
- إدارة حساب واحد
- 8 منشورات شهرياً
- تصميمات جذابة
- كتابة محتوى
- جدولة المنشورات
- رد على التعليقات

أرغب في معرفة السعر والبدء.`
    },
    {
      id: 'gold',
      title: 'الباقة الذهبية',
      subtitle: 'الشركات الصغيرة والمتوسطة',
      badge: 'الأكثر طلباً',
      isFeatured: true,
      features: [
        'إدارة حسابين (Instagram + Facebook)',
        '15 منشور شهرياً',
        'تصميمات احترافية مع هوية موحدة',
        'كتابة محتوى متنوع وجذاب',
        'جدولة ذكية حسب أوقات الذروة',
        'رد على جميع التعليقات والرسائل',
        '2 ستوري أسبوعياً',
        'تقرير تحليلي شامل',
        'اقتراحات للتحسين'
      ],
      whatsappMessage: `مرحباً

أنا مهتم بـــ الباقة الذهبية لإدارة السوشيال ميديا

تفاصيل الباقة:
- إدارة حسابين (Instagram + Facebook)
- 15 منشور شهرياً
- تصميمات احترافية
- جدولة ذكية
- رد على الرسائل
- 2 ستوري أسبوعياً
- تقرير تحليلي

أرغب في معرفة السعر وحجز استشارة.`
    },
    {
      id: 'pro',
      title: 'الباقة الاحترافية',
      subtitle: 'العلامات التجارية الكبيرة',
      isFeatured: false,
      features: [
        'إدارة 3 منصات (Instagram + Facebook + TikTok أو X)',
        '25 منشور شهرياً',
        'محتوى مخصص ومتنوع (صور، فيديوهات، Reels)',
        'استراتيجية محتوى شهرية',
        'تصوير ومونتاج فيديوهات قصيرة (4 فيديوهات)',
        'حملات تفاعل (مسابقات، استطلاعات)',
        'رد فوري على الرسائل والتعليقات',
        '5 ستوري أسبوعياً',
        'تقرير تحليلي مفصّل',
        'اجتماع شهري لمناقشة الأداء',
        'تحسين مستمر للاستراتيجية'
      ],
      whatsappMessage: `مرحباً

أنا مهتم بـــ الباقة الاحترافية لإدارة السوشيال ميديا

تفاصيل الباقة:
- إدارة 3 منصات
- 25 منشور شهرياً
- محتوى متنوع (صور + فيديوهات)
- 4 فيديوهات قصيرة
- حملات تفاعل
- 5 ستوري أسبوعياً
- اجتماع شهري

أرغب في معرفة السعر والتفاصيل.`
    }
  ],

  roiInsights: {
    title: "العائد على الاستثمار في السوشيال ميديا",
    subtitle: "أرقام وحقائق تثبت قيمة الاستثمار في إدارة السوشيال ميديا",
    insights: [
      {
        id: 1,
        icon: FaChartLine,
        title: "عائد استثمار 400%",
        description: "متوسط العائد على الاستثمار في التسويق عبر السوشيال ميديا"
      },
      {
        id: 2,
        icon: FaUsers,
        title: "70% من المستهلكين",
        description: "يثقون في توصيات المنتجات على وسائل التواصل الاجتماعي"
      },
      {
        id: 3,
        icon: FaBullhorn,
        title: "زيادة الوعي 80%",
        description: "الشركات التي تدير حساباتها باحتراف تحقق زيادة بالوعي بالعلامة التجارية"
      },
      {
        id: 4,
        icon: FaComments,
        title: "تفاعل أعلى 6 مرات",
        description: "المحتوى الاحترافي يحقق تفاعل أعلى من المحتوى العشوائي"
      }
    ]
  },

  valueProposition: {
    title: "لماذا الإدارة الاحترافية أفضل؟",
    subtitle: "الفرق بين إدارة عشوائية وإدارة احترافية",
    comparisons: [
      {
        id: 1,
        icon: FaLightbulb,
        title: "استراتيجية مدروسة",
        description: "نخطط كل منشور بناءً على تحليل الجمهور وأهدافك، لا نشر عشوائي"
      },
      {
        id: 2,
        icon: FaPencilAlt,
        title: "محتوى احترافي",
        description: "تصاميم وكتابة احترافية تجذب الانتباه وتحفز التفاعل"
      },
      {
        id: 3,
        icon: FaChartLine,
        title: "قياس النتائج",
        description: "تقارير دورية توضح الأداء والنمو وتساعد على التحسين المستمر"
      },
      {
        id: 4,
        icon: FaComments,
        title: "إدارة التفاعل",
        description: "رد احترافي وسريع على جميع التعليقات والرسائل يبني علاقة قوية مع العملاء"
      }
    ]
  },

  process: {
    title: "كيف نعمل؟",
    steps: [
      {
        id: 1,
        number: "1",
        icon: FaComments,
        title: "الاستشارة الأولية",
        description: "نتعرف على مشروعك وأهدافك وجمهورك"
      },
      {
        id: 2,
        number: "2",
        icon: FaLightbulb,
        title: "وضع الاستراتيجية",
        description: "نصمم خطة محتوى شهرية مدروسة"
      },
      {
        id: 3,
        number: "3",
        icon: FaPencilAlt,
        title: "إنشاء المحتوى",
        description: "نصمم وننتج المنشورات والفيديوهات"
      },
      {
        id: 4,
        number: "4",
        icon: FaCheckCircle,
        title: "المراجعة والموافقة",
        description: "نرسل لك المحتوى قبل النشر للموافقة"
      },
      {
        id: 5,
        number: "5",
        icon: FaPaperPlane,
        title: "النشر والمتابعة",
        description: "ننشر في الأوقات المثالية ونتابع التفاعل"
      },
      {
        id: 6,
        number: "6",
        icon: FaChartLine,
        title: "التحليل والتطوير",
        description: "نحلل الأداء ونحسّن الاستراتيجية شهرياً"
      }
    ]
  },

  successStories: {
    title: "قصص نجاح من عملائنا",
    stories: [
      {
        id: 1,
        icon: FaInstagram,
        title: "متجر ملابس",
        description: "زيادة المتابعين من 2,000 إلى 15,000 في 6 أشهر",
        result: "تحسن التفاعل بنسبة 400%"
      },
      {
        id: 2,
        icon: FaChartLine,
        title: "مطعم محلي",
        description: "زيادة الطلبات من السوشيال ميديا بنسبة 250%",
        result: "نمو المتابعين من 800 إلى 8,500"
      },
      {
        id: 3,
        icon: FaBullhorn,
        title: "خدمات تقنية",
        description: "توليد أكثر من 50 استفسار شهرياً",
        result: "بناء سمعة قوية في السوق"
      }
    ]
  },

  faq: {
    title: "أسئلة شائعة",
    items: [
      {
        id: 1,
        question: "هل أحتاج للموافقة على المنشورات قبل النشر؟",
        answer: "نعم، نرسل لك المحتوى مسبقاً للموافقة"
      },
      {
        id: 2,
        question: "كم مرة تنشرون في الأسبوع؟",
        answer: "يعتمد على الباقة (2-6 منشورات أسبوعياً)"
      },
      {
        id: 3,
        question: "هل تصورون المحتوى بأنفسكم؟",
        answer: "في الباقة الاحترافية نعم، أو يمكنك إرسال صور منتجاتك"
      },
      {
        id: 4,
        question: "ماذا لو أردت تغيير في الاستراتيجية؟",
        answer: "نجتمع شهرياً لمراجعة الأداء والتعديل"
      },
      {
        id: 5,
        question: "هل تردون على الرسائل والتعليقات؟",
        answer: "نعم، نرد خلال ساعات العمل بشكل احترافي"
      }
    ]
  },

  finalCTA: {
    title: "جاهز لحسابات سوشيال ميديا نشطة؟",
    subtitle: "تواصل معنا وابدأ رحلة النمو الرقمي",
    buttonText: "ابدأ الآن"
  }
};
